import React from 'react';
import PropTypes from 'prop-types';

const PresetButton = ({ onClick, preset, isSelected, customColors }) => {
  const { name, colors } = preset;

  return (
    <button
      onClick={onClick}
      className={`
        relative p-3 rounded-lg border-2 transition-all duration-200 w-full min-w-0
        hover:shadow-lg hover:scale-105 hover:border-accent
        focus:outline-none focus:ring-2 focus:ring-offset-2
        ${isSelected ? 'shadow-md' : 'border-accent bg-white'}
      `}
      style={isSelected ? {
        borderColor: customColors.primary,
        backgroundColor: `${customColors.primary}0D`, // 5% opacity
      } : {}}
      aria-label={`Select ${name} color preset`}
      aria-pressed={isSelected}
    >
      <div className="mb-3 flex items-center justify-between">
        <span className="text-sm font-medium text-secondary">{name}</span>
      </div>
      <div className="grid grid-cols-5 gap-1">
        {Object.entries(colors).map(([key, color]) => (
          <div
            key={key}
            className="h-8 rounded border border-gray-300 shadow-sm"
            style={{ backgroundColor: color }}
            title={key.charAt(0).toUpperCase() + key.slice(1)}
            aria-label={`${key} color`}
          />
        ))}
      </div>
      {isSelected && (
        <div className="absolute top-2 right-2">
          <span 
            className="inline-flex items-center justify-center w-6 h-6 rounded-full text-surface"
            style={{ backgroundColor: customColors.primary }}
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </span>
        </div>
      )}
    </button>
  );
};

PresetButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  preset: PropTypes.shape({
    name: PropTypes.string.isRequired,
    colors: PropTypes.shape({
      primary: PropTypes.string.isRequired,
      secondary: PropTypes.string.isRequired,
      accent: PropTypes.string.isRequired,
      neutral: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  customColors: PropTypes.object.isRequired,
};

export default PresetButton;
